export default __webpack_public_path__ + "static/media/spin.2b7aa53c.png";